export default "Private Ownership has <b>high investment efficiency</b>.\n";